import { render, staticRenderFns } from "./StatementDialog.vue?vue&type=template&id=55fdf72f&scoped=true"
import script from "./StatementDialog.vue?vue&type=script&lang=js"
export * from "./StatementDialog.vue?vue&type=script&lang=js"
import style0 from "./StatementDialog.vue?vue&type=style&index=0&id=55fdf72f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fdf72f",
  null
  
)

export default component.exports